const border = {
  default: `1px solid #caced8`
};

export const fallbackValues = {
  border
};
